<template>
<ItpRow>
  <ItpCol
    w="5"
  >
    <BListGroup
      flush
      class="list-group-alt-1"
    >
      <ItpLabeledListGroupItem
        :label="'Own company'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
      >
        <UcCompanyMiniCard
          role="own"
          :item="invoice.company"
          no-icon
        >
        </UcCompanyMiniCard>
        <UcInvoicePartyPanel
          :item="invoice.company"
          v-if="invoice.company"
        >
        </UcInvoicePartyPanel>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Partner'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
      >
        <UcCompanyMiniCard
          role="partner"
          :item="invoice.client"
          no-icon
        >
        </UcCompanyMiniCard>
        <UcInvoicePartyPanel
          :item="invoice.client"
          v-if="invoice.client"
        >
        </UcInvoicePartyPanel>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Invoice date'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.invoice_date"
      >
        <ItpText
          strong
        >
          {{ invoice.invoice_date | date }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Fulfillment date'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.fulfillment_date"
      >
        <ItpText
          strong
        >
          {{ invoice.fulfillment_date | date }}
        </ItpText>
        <span
          class="itp-badge badge-warning ml-2"
          v-if="invoice.meta
  && invoice.meta.calculated_fulfillment_date
  && invoice.meta.calculated_fulfillment_date != invoice.fulfillment_date"
        >
          <icon icon="ant-design:warning-filled"></icon>
{{ invoice.meta.calculated_fulfillment_date | date }}

        </span>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Billing period'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.billing_period && (invoice.billing_period.start || invoice.billing_period.end)"
      >
        <DIV
          class="text-nowrap"
        >
          <strong
            v-if="invoice.billing_period.start"
          >
            {{ invoice.billing_period.start | date }}
          </strong>
          <strong
            v-if="!invoice.billing_period.start"
          >
            n/a
          </strong>
          <strong>
            -
          </strong>
          <strong
            v-if="invoice.billing_period.end"
          >
            {{ invoice.billing_period.end | date }}
          </strong>
          <strong
            v-if="!invoice.billing_period.end"
          >
            n/a
          </strong>
        </DIV>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Accounting Date'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.accounting_date"
      >
        <ItpText
          strong
        >
          {{ invoice.accounting_date | date }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'VAT Period'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.vat_period && invoice.vat_period.name"
      >
        <ItpText
          strong
        >
          {{ invoice.vat_period.name }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Email Template'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.email_template && invoice.email_template.name"
      >
        <ItpText
          strong
        >
          {{ invoice.email_template.name }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Reference Number'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.reference_number"
      >
        <ItpText
          strong
        >
          {{ invoice.reference_number }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Order Number'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.order_number"
      >
        <ItpText
          strong
        >
          {{ invoice.order_number }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'File Number'|pgettext('Invoice')"
        :labelCols="leftColumnLabelCols"
        class="mb-2"
        v-if="invoice.file_number"
      >
        <ItpText
          strong
        >
          {{ invoice.file_number }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <BListGroup
        flush
        class="list-group-alt-1 mb-2"
      >
        <ItpLabeledListGroupItem
          :label="'Notes'|pgettext('Invoice')"
          :labelCols="leftColumnLabelCols"
        >
          <MultilineNotes
            :value="invoice.notes"
            :editable="!invoice.locked"
            @save="evh_388211655357085_save($event, {})"
          >
          </MultilineNotes>
        </ItpLabeledListGroupItem>
      </BListGroup>
      <BListGroup
        flush
        class="list-group-alt-1"
        v-if="invoice.internal_notes"
      >
        <ItpLabeledListGroupItem
          :label="'Internal Notes'|pgettext('Invoice')"
          :labelCols="leftColumnLabelCols"
        >
          <ItpText
            :text="invoice.internal_notes"
            pre
          >
          </ItpText>
        </ItpLabeledListGroupItem>
      </BListGroup>
    </BListGroup>
  </ItpCol>
  <ItpCol
    w="7"
  >
    <BListGroup
      flush
      class="list-group-alt-1"
    >
      <ItpLabeledListGroupItem
        :label="'Currency'|pgettext('Invoice')"
        strong
        class="mb-2"
        v-if="invoice.currency"
      >
        <ItpText
          strong
        >
          {{ invoice.currency }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Exchange rate'|pgettext('Invoice')"
        strong
        class="mb-2"
        v-if="invoice.exchange_rate && invoice.exchange_rate != 1"
      >
        <ItpText
          strong
        >
          {{ invoice.exchange_rate | number }}
<span v-if="invoice.exchange_rate_bank">
  &middot; {{ invoice.exchange_rate_bank }}
</span>
<span v-if="invoice.exchange_rate_date">
  ({{ invoice.exchange_rate_date | date }})
</span>

        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Due date'|pgettext('Invoice')"
        class="mb-2"
        v-if="invoice.due_date"
      >
        <ItpText
          strong
        >
          {{ invoice.due_date | date }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Payment Method'|pgettext('Invoice')"
        class="mb-2"
        v-if="invoice.payment_method"
      >
        <ItpText
          strong
        >
          {{ invoice.payment_method  | pgettext('PaymentMethod', 'Sentence') }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Expense Type'|pgettext('Invoice')"
        class="mb-2"
        v-if="invoice.expense_type"
      >
        <ItpText
          strong
        >
          {{ invoice.expense_type | pgettext('ExpenseType', 'Sentence') }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Register entries'|pgettext('Invoice')"
        class="mb-2"
        v-if="invoice.register_entries.data && invoice.register_entries.data.length"
      >
        <UcRegisterEntryMiniCard
          :key="entry.id"
          :item="entry"
          no-icon
          v-for="entry in invoice.register_entries.data"
        >
        </UcRegisterEntryMiniCard>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'References'|pgettext('Invoice')"
        class="mt-2 mb-2"
      >
        <UcInvoiceReferences
          :invoice="invoice"
          :reload="lastLoaded"
          @reload="evh_4152404563918957_reload($event, {})"
        >
        </UcInvoiceReferences>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Attachments'|pgettext('Invoice')"
        class="mt-2 mb-2"
      >
        <UcAttachmentsPanel
          :parent_id="invoice.id"
          :parent="invoice"
          :readonly="invoice.isReadonly"
          :reload="lastLoaded"
          @reload="evh_3855552110905499_reload($event, {})"
        >
        </UcAttachmentsPanel>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Payments'|pgettext('Invoice')"
        class="mt-2 mb-2"
        v-if="invoice.totals"
      >
        <UcInvoicePayments
          :invoice="invoice"
          :reload="lastLoaded"
          @reload="evh_4039445435535707_reload($event, {})"
        >
        </UcInvoicePayments>
      </ItpLabeledListGroupItem>
    </BListGroup>
  </ItpCol>
</ItpRow>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceData extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onSaveNotes(...args: any[]) {
    console.log(this.invoice.notes);
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: function() {
      return this.$fn.randomElementId()
    },
  })
  formId!: string;

  @Watch('formId')
  onForm_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("formId")
  }

  leftColumnLabelCols!: any;
  ux!: any;
  dataMembers = ['leftColumnLabelCols', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        leftColumnLabelCols: 4,
        ux: null,
      },
    }
  }

  get isReadonly() {
    if (this.loaded) {

      return false
    }
    return null;
  }

  get invoiceTypeName() {
    if (this.loaded) {

      return this.invoice.invoice_type === "correction" ? this.$fn.pgettext("InvoiceType", "Correction") :
        (this.invoice.invoice_type === "storno" ? this.$fn.pgettext("InvoiceType", "Storno") :
          (this.invoice.invoice_type === "proforma" ? this.$fn.pgettext("InvoiceType", "Pro Forma") : "?"))
    }
    return null;
  }

  async act_388211655357085_emit_7484_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_388211655357085_emit_7484, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_388211655357085_request_7482_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_388211655357085_request_7482, alias=saveNotes
    return {
      operation: "update_invoice_notes",
      data: { id: this.invoice.id, text: $event.data.value.text },
    }
  }

  async evh_388211655357085_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_388211655357085_save.executeFromDOM(this, event, scope);
  }

  async act_4152404563918957_emit_7486_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4152404563918957_emit_7486, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4152404563918957_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4152404563918957_reload.executeFromDOM(this, event, scope);
  }

  async act_3855552110905499_emit_7488_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3855552110905499_emit_7488, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_3855552110905499_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3855552110905499_reload.executeFromDOM(this, event, scope);
  }

  async act_4039445435535707_emit_7490_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4039445435535707_emit_7490, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_4039445435535707_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4039445435535707_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_388211655357085_emit_7484: actions.EmitAction;
    evh_388211655357085_success_7483: actions.EventHandlerImpl;
    act_388211655357085_request_7482: actions.RequestAction;
    evh_388211655357085_save_7481: actions.EventHandlerImpl;
    evh_388211655357085_save: actions.EventHandlerGroup;
    act_4152404563918957_emit_7486: actions.EmitAction;
    evh_4152404563918957_reload_7485: actions.EventHandlerImpl;
    evh_4152404563918957_reload: actions.EventHandlerGroup;
    act_3855552110905499_emit_7488: actions.EmitAction;
    evh_3855552110905499_reload_7487: actions.EventHandlerImpl;
    evh_3855552110905499_reload: actions.EventHandlerGroup;
    act_4039445435535707_emit_7490: actions.EmitAction;
    evh_4039445435535707_reload_7489: actions.EventHandlerImpl;
    evh_4039445435535707_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_388211655357085_emit_7484 = new actions.EmitAction(
      {
        actionArgs: this.act_388211655357085_emit_7484_getActionArgs,
        events: [],
      }
    );
    const evh_388211655357085_success_7483 = new actions.EventHandlerImpl(
      {
        action: act_388211655357085_emit_7484,
        event: "success",
        displayName: "emit",
      }
    );
    const act_388211655357085_request_7482 = new actions.RequestAction(
      {
        actionArgs: this.act_388211655357085_request_7482_getActionArgs,
        displayName: "saveNotes",
        events: [evh_388211655357085_success_7483],
      }
    );
    const evh_388211655357085_save_7481 = new actions.EventHandlerImpl(
      {
        action: act_388211655357085_request_7482,
        event: "save",
        displayName: "saveNotes",
      }
    );
    const evh_388211655357085_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_388211655357085_save_7481],
      }
    );
    const act_4152404563918957_emit_7486 = new actions.EmitAction(
      {
        actionArgs: this.act_4152404563918957_emit_7486_getActionArgs,
        events: [],
      }
    );
    const evh_4152404563918957_reload_7485 = new actions.EventHandlerImpl(
      {
        action: act_4152404563918957_emit_7486,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_4152404563918957_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_4152404563918957_reload_7485],
      }
    );
    const act_3855552110905499_emit_7488 = new actions.EmitAction(
      {
        actionArgs: this.act_3855552110905499_emit_7488_getActionArgs,
        events: [],
      }
    );
    const evh_3855552110905499_reload_7487 = new actions.EventHandlerImpl(
      {
        action: act_3855552110905499_emit_7488,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_3855552110905499_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_3855552110905499_reload_7487],
      }
    );
    const act_4039445435535707_emit_7490 = new actions.EmitAction(
      {
        actionArgs: this.act_4039445435535707_emit_7490_getActionArgs,
        events: [],
      }
    );
    const evh_4039445435535707_reload_7489 = new actions.EventHandlerImpl(
      {
        action: act_4039445435535707_emit_7490,
        event: "reload",
        displayName: "emit",
      }
    );
    const evh_4039445435535707_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_4039445435535707_reload_7489],
      }
    );
    return {
      act_388211655357085_emit_7484,
      evh_388211655357085_success_7483,
      act_388211655357085_request_7482,
      evh_388211655357085_save_7481,
      evh_388211655357085_save,
      act_4152404563918957_emit_7486,
      evh_4152404563918957_reload_7485,
      evh_4152404563918957_reload,
      act_3855552110905499_emit_7488,
      evh_3855552110905499_reload_7487,
      evh_3855552110905499_reload,
      act_4039445435535707_emit_7490,
      evh_4039445435535707_reload_7489,
      evh_4039445435535707_reload,
      saveNotes: act_388211655357085_request_7482,
    }
  }
}

Vue.component("UcInvoiceData", UcInvoiceData);

</script>